module.exports = __webpack_public_path__ + "static/media/Bluefamily.df3728c7.svg";